import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile';
import './index.scss';
import mask from 'image/download-new/mask.png';
import LogoPng from 'image/download-new/logo.png';
import DownBtnPng from 'image/download-new/down-btn.png';
import Page1Png from 'image/download-new/1.png';
import Page2Png from 'image/download-new/2.png';
import Page3Png from 'image/download-new/3.png';
import Page4Png from 'image/download-new/4.png';
import Page5Png from 'image/download-new/5.png';
import Page6Png from 'image/download-new/6.png';
import Page7Png from 'image/download-new/7.png';
import Page8Png from 'image/download-new/8.png';
import iOSBtnPng from 'image/download-new/iOS.png';
import AndroidBtnPng from 'image/download-new/Android.png';
import { queryParse } from '~/utils/query';
import { getLatestFullVersion } from '~/api';
import { www } from '~/utils/hosts';

import CallApp from '~/lib/call-app';

function checkBrowser() {
  const u = navigator.userAgent,
    app = navigator.appVersion;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('HarmonyOS'); // android终端或者uc浏览器
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/ipad|mac\s?os?x?|macintosh/ig); // ios终端 || ipad
  const isWX = (/micromessenger/i).test(u);
  const isAlipay = (/AlipayClient/i).test(u);
  const QQBrowser = u.match(/qq/i) != null || u.match(/qqbrowse/i) != null || u.match(/qq/i) != null;
  const isIosQQ = (isiOS && / QQ/i.test(u));
  const isAndroidQQBrowser = (isAndroid && /MQQBrowser/i.test(u) && !(/QQ/i.test((u).split('MQQBrowser'))));
  const isDingTalk = (/dingtalk/i).test(u);
  const isHarmony = (/ArkWeb/i).test(u);
  return { app, isAndroid, isiOS, isWX, isAlipay, QQBrowser, isIosQQ, isAndroidQQBrowser, isDingTalk, isHarmony };
}

const {
  isiOS, isWX, isAlipay, QQBrowser,
  isAndroidQQBrowser, isDingTalk, isHarmony,
} = checkBrowser();
let { domain, action, params, letterId, qd } = queryParse(window.location.search);
let router = '';
try {
  params = JSON.parse(params);
  const routerObj = JSON.stringify({
    domain,
    action,
    params,
  });
  router = encodeURIComponent(`mistong://${routerObj}`);
  // eslint-disable-next-line no-empty
} catch (e) {
}

const callLib = new CallApp({
  scheme: {
    protocol: 'ewt',
    host: 'www.ewt360.com',
  },
  intent: {
    scheme: 'ewt',
    package: 'com.mistong.ewt360',
  },
  appstore: 'https://itunes.apple.com/cn/app/id1027705496',
  fallback: '//app.ewt360.com/app.htm?t=zA3aIr',
});

class Download extends Component {
  componentDidMount() {
    if (isHarmony) {
      Modal.alert('温馨提示', '鸿蒙设备请到应用商店下载升学e网通App哦～');
    } else {
      this.callApp();
    }
  }

  downAction = () => {
    if (isiOS && !!qd) {
      Toast.info('暂无iOS版本，请使用电脑下载', 3);
      return;
    }
    if (!isiOS) {
      getLatestFullVersion({
        data: { channelId: qd ? 2 : 1 },
      }).then((res) => {
        window.location.href = res.data[0].downloadUrl;
      });
      return;
    }
    // 如果ios系统的。直接到应用商店去
    window.location.href = 'https://itunes.apple.com/us/app/sheng-xuee-wang-tong/id1027705496?l=zh&ls=1&mt=8';
  }

  callApp = () => {
    if (isWX || isAlipay || (QQBrowser && !isAndroidQQBrowser)) return;
    if (isiOS && !!qd) {
      Toast.info('暂无iOS版本，请使用电脑下载', 3);
      return;
    }
    callLib.open({
      path: '',
      param: {
        router,
        letterId,
      },
      callback: () => {
        console.log('error');
      },
    });
  };

  render() {
    return (
      (isWX || isAlipay || (QQBrowser && !isAndroidQQBrowser) || isDingTalk) ? (
        <div className="wrap">
          <div className="maskWrap">
            <div className="mask">
              <img className="mask-img" src={mask} alt="请用浏览器打开" />
            </div>
          </div>
        </div>
      ) : (
        <div className="wrap">
          <div onClick={this.callApp} className="fixed-bar">
            <img src={LogoPng} className="top-logo" alt="ewt360" />
            {
              !isHarmony && (
                <div onClick={() => this.downAction()}>
                  <img src={DownBtnPng} className="top-btn-img" alt="ewt360" />
                </div>
              )
            }
          </div>
          <div className="topSection">
            <div className="page-top-box">
              <div className="img-box">
                <img src={Page1Png} className="top-page-img" alt="ewt360" />
              </div>
            </div>
            <div className="downMenuWrapper">
              {!isHarmony && (
                <div className="downMenu" onClick={() => this.downAction()}>
                  {isiOS && <img src={iOSBtnPng} alt="" />}
                  {isiOS && <div className="menuText">&nbsp;APP下载</div>}
                  {!isiOS && <img src={AndroidBtnPng} alt="" />}
                  {!isiOS && <div className="menuText">&nbsp;Android版下载</div>}
                </div>
              )}
            </div>
            <div className="pcLink">
              <a href={`${www}?from=appDownloadPage`}>访问网页版</a>
            </div>
          </div>
          {/* E讲堂 */}
          <div className="moduleBox">
            <img src={Page2Png} alt="" />
            <img src={Page3Png} alt="" />
            <img src={Page4Png} alt="" />
            <img src={Page5Png} alt="" />
            <img src={Page6Png} alt="" />
            <img src={Page7Png} alt="" />
            <img src={Page8Png} alt="" />
          </div>
        </div>
      )
    );
  }
}
export default Download;



// WEBPACK FOOTER //
// ./src/components/pages/download/index.jsx